<template>
  <div class="bg">
    <div class="bc">
      <div class="up_space"/>
      <img class="img_title" src="/img/image/home/t_14.png" loading="lazy" alt="常見問題">
      <div class="title_space"/>
      <div class="accordion-1">
        <div class="accordion" id="accordionExample">
          <div class="card" v-for="(item) in questions" :key="item.id">
            <div class="card-header p-0" :id="`heading-${item.id}`">
              <h5 class="mb-0">
                <button class="btn w-100" type="button"
                        data-toggle="collapse" :data-target="`#collapse-${item.id}`" aria-expanded="false"
                        :aria-controls="`collapse-${item.id}`"
                        style="word-break: break-all; white-space: normal;"
                >
                  <div class="row no-gutters align-items-center">
                    <span class="h5 col-auto text-primary font-weight-700">Q</span>
                    <div style="width: 8px;"/>
                    <span class="h5 col text-custom-text text-left">{{ item.question }}</span>
                    <div style="width: 8px;"/>
                    <img class="img_icon col-auto ni float-right" src="/img/image/icon/top.png" loading="lazy" alt>
                  </div>
                </button>
              </h5>
            </div>
            <div :id="`collapse-${item.id}`" class="collapse" :aria-labelledby="`heading-${item.id}`"
                 data-parent="#accordionExample">
              <div class="rounded-top-0 rounded-1 bg-collapse">
                <div style="height: 10px;"/>
                <div class="row no-gutters">
                  <div style="width: 24px;"/>
                  <span class="h5  col-auto text-custom-text font-weight-700">A</span>
                  <div style="width: 8px;"/>
                  <span class="h5 col text-custom-text text-left">{{ item.answer }}</span>
                </div>
                <div style="height: 10px;"/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="height: 54px;"/>
  </div>
</template>

<script>
import {getQuestionAndAnswers} from "@/api/api";

export default {
  name: "Stage_10",
  data() {
    return {
      questions: [],
    };
  },
  created() {
    this.getQuestionAndAnswers();
  },
  methods: {
    async getQuestionAndAnswers() {
      try {
        let response = await getQuestionAndAnswers();
        this.questions = response.data;
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bg {
  background-image: url('/img/image/background/bg_s11.png');
  background-size: cover; /* 确保背景图像覆盖整个元素 */
  background-position: center; /* 将图像居中 */
  background-repeat: no-repeat; /* 防止图像重复 */
}

.bc {
  margin: 0 auto;
  height: auto;
  max-width: 1440px;
  text-align: center;
}


.up_space {
  height: 55px;
}

@media (max-width: 576px) {
  .up_space {
    height: 36px;
  }
}

@media (max-width: 360px) {
  .up_space {
    height: 24px;
  }
}

//文字 常見問題
.img_title {
  width: 300px;
  height: auto;
  object-fit: cover;
}

@media (max-width: 576px) {
  .img_title {
    width: 180px;
  }
}

@media (max-width: 360px) {
  .img_title {
    width: 155px;
  }
}

.title_space {
  height: 20px;
}

.accordion-1 {
  width: 900px;
  margin: 0 auto;
}

@media (max-width: 991px) {
  .accordion-1 {
    width: 90vw;
  }
}

@media (max-width: 576px) {
  .accordion-1 {
    width: 93vw;
  }
}

@media (max-width: 360px) {
  .accordion-1 {
    width: 260px;
  }
}

.card {
  margin-bottom: 24px;
}


.img_icon {
  width: 20px;
  height: 20px;
  object-fit: cover; /* 确保图片覆保持比例 */
}


</style>
